import { z } from 'zod';

export enum ExploreEventType {
  SHOT = 'SHOT',
}

export const exploreEventTypeSchema = z.enum(ExploreEventType);
